/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrReConfigAuthIdentity } from './irrReConfigAuthIdentity';
import { IrrConfigAuthAsup } from './irrConfigAuthAsup';
import { IrrCspServiceConfig } from './irrCspServiceConfig';
import { IrrReConfigAuthUi } from './irrReConfigAuthUi';


export interface IrrReConfigAuth { 
    asup?: IrrConfigAuthAsup;
    identity?: IrrReConfigAuthIdentity;
    ui?: IrrReConfigAuthUi;
    vcf?: IrrCspServiceConfig;
    vmc?: IrrCspServiceConfig;
}

